<template>
  <section>
    <search :searchStatus="false"></search>
    <section class="padding-footer">
      <div class="util-list-header">
        <div>
          <img src="@/assets/img/util-tab-1-title.svg" />
        </div>
        <div class="util-list-header-title">
          <strong>Pencatatan Listrik</strong>
          <span>Listrik Notes History</span>
        </div>
      </div>
      <util-date :dates="dates" @apply="filter"></util-date>
      <b-container>
        <util-item-listrik :listdata="list"></util-item-listrik>
        <div v-show="page < data?.last_page" @click="loadMore" class="load-more">Load More</div>
      </b-container>
    </section>
    <!-- <MenuFooter /> -->
    <util-add action="/utilities/listrik/add" v-if="group == 'Operator Utilities'"></util-add>
  </section>
</template>
<script lang="js">
import dayjs from "dayjs";

import Vue from "vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilItemListrik from "@/views/pages/Utilities/Components/Util-Item-Listrik.vue";
import UtilAdd from "@/views/pages/Utilities/Components/Util-Add.vue";
import UtilDate from "@/views/pages/Utilities/Components/Util-Date.vue";
import { api } from "@/api/api.js";
import { UserModule } from "@/store/modules/user";

@Component({
    components: {
        MenuFooter,
        Search,
        UtilItemListrik,
        UtilAdd,
        UtilDate,
    },
})
export default class UtilitiesListListrik extends Vue {
  dayjs = dayjs
  dates = {start:dayjs().subtract(7, "days").format("YYYY-MM-DD"),end:dayjs().format("YYYY-MM-DD")}
  list = [];
  filter(e){
    this.dates = e
    this.search()
  }
  data = null
  search(){
    api('listrik_list',{params:{date_start: this.dates.start, date_end: this.dates.end}}).then(res => {
      this.list = res.data.data.map(e=>{
        e.date = new Date(e.usage_date);
        return e
      })
      this.page = 1
      this.data = res.data
    })
  }
  page = 1
  loadMore(){
    api('listrik_list',{params:{date_start: this.dates.start, date_end: this.dates.end, page: this.page+1}}).then(res => {
      this.list = this.list.concat(res.data.data).map(e=>{
        e.date = new Date(e.usage_date);
        return e
      })
      this.data = res.data
    })
  }
  mounted(){
    this.search()
  }
  group = UserModule.userDetail.accessgroup['name']
}
</script>
